export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    //console.log('WORKING');
    $('.nav-primary .nav > li.menu-item-has-children > .sub-menu > li').hover(function(){
      //console.log('hover works');
      $(this).siblings().removeClass('active');
      $(this).addClass('active');
    });

    $(window).scroll(function () {
      var height = $(window).scrollTop();
      if (height > 100) {
        $("header.banner").addClass('sticked');
      } else {
        $("header.banner").removeClass('sticked');
      }
    });

    $('.widget .gallery').slick({
      infinite: true,
      arrows: false,
      speed: 300,
      slidesToShow: 1,
      //variableWidth: true,
      autoplay: true,
      autoplaySpeed: 3000,
    })

    $('#nav-icon').click(function(){
      $('body').toggleClass('menu-open');
      $(this).toggleClass('open');
    });

    $('.nav-mob .menu-item-has-children > a').each(function(){
      $(this).append('<span class="expand-sub"></span>');
    });

    $('.nav-mob .expand-sub').click(function(e){
      e.preventDefault();
      $(this).closest('li').toggleClass('sub-menu-open');
      $(this).closest('li').siblings().removeClass('sub-menu-open');
    });

    $('.search-form .search-submit').click(function(e){
      if ( $(this).parent().hasClass('active') ) {
        $(this).parent().removelass('active');
      }else{
        $(this).parent().addClass('active');
        e.preventDefault();
        e.stopPropagition();
      }
    })
    
    $('.gdpr-preferences').on('click', function(){
        var cLang = $('#c-lang').text();
        if (cLang == 'fr') {
          window.location.href = 'politica-de-cookies';
        }else{
          window.location.href = 'privacy-policy';
        }
    });
      

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js